import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import { Subscription, Observable, Subject } from 'rxjs';
import { ViewportService } from '../../core/services/viewport.service';
import { ViewPort } from '../../domain/view-port.model';
import { UiOrchestratorService } from '../../core/services/ui-orchestrator.service';
import { ScrollEventService } from '../scroll-event.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'fts-step-controls',
  templateUrl: 'step-controls.component.html',
  styleUrls: ['step-controls.component.scss'],
})
export class StepControlsComponent implements OnInit, AfterViewInit, OnDestroy {
  hasFixedPosition = false;

  @Input()
  hasBackBtn: boolean;
  @Input()
  hasForwardBtn: boolean;
  @Input()
  hasSubmitBtn: boolean;
  @Input()
  forwardBtnItemLabel: string;
  @Input()
  submitBtnLabel: string;
  @Input()
  forwardBtnDisabled: boolean;
  @Input()
  isItemValid: boolean;
  @Input()
  submitLoadingSubscription: Subscription;
  @Input()
  isHalfAndHalf = false;

  @Output()
  backBtnClick = new EventEmitter<void>();
  @Output()
  forwardBtnClick = new EventEmitter<void>();
  @Output()
  submitBtnClick = new EventEmitter<void>();

  public viewPort$: Observable<ViewPort>;
  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private el: ElementRef,
    private viewPortService: ViewportService,
    private uiOrchestrationService: UiOrchestratorService,
    private scrollService: ScrollEventService,
    private cdRef: ChangeDetectorRef
  ) {
    this.viewPort$ = this.viewPortService.viewport$;
  }

  @ViewChild('wrapper', { static: true })
  wrapper: ElementRef;

  @HostListener('window:orientationchange', [])
  handleResize() {
    this.checkPosition();
  }

  ngOnInit() {
    this.uiOrchestrationService.stepControlsPositionChange$.subscribe(() => this.checkPosition());
    this.scrollService.throttledScrollAndResize$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.checkPosition();
      this.cdRef.detectChanges();
    });
  }

  ngAfterViewInit() {
    this.checkPosition();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onBackBtnClick() {
    this.backBtnClick.emit();
  }

  onForwardBtnClick() {
    this.forwardBtnClick.emit();
  }

  onSubmitBtnClick() {
    this.submitBtnClick.emit();
  }

  private checkPosition() {
    const wrapperStyle = this.wrapper.nativeElement.style;
    const left = this.el.nativeElement.getBoundingClientRect().left;
    this.hasFixedPosition = this.el.nativeElement.getBoundingClientRect().top >= window.innerHeight;
    if (this.hasFixedPosition) {
      wrapperStyle.width = '';
      wrapperStyle.left = '';
    } else {
      wrapperStyle.width = `${window.innerWidth}px`;
      wrapperStyle.left = `-${left}px`;
    }
  }
}
